import { ColorOptions } from "@/src/types";
import { MainInner, StyledMainSection } from "@/styles/global";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Inner = styled(MainInner)`
  padding-block: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-block: 40px;
  }
`;

const Wrapper = styled.div<{
  $backgroundColor: ColorOptions;
  $backgroundType: "card" | "fill";
}>`
  position: relative;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ theme, $backgroundColor, $backgroundType }) =>
    $backgroundType === "card"
      ? "transparent"
      : theme.colors[$backgroundColor]};
`;

const IconContainer = styled.div<{ $backgroundType: "card" | "fill" }>`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    position: absolute;
    display: block;
    width: ${({ $backgroundType }) =>
      $backgroundType === "card" ? `calc(100% - 32px)` : "100%"};
    z-index: 10;
    left: 16px;
  }
`;

const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Card = styled.div`
  flex: 0 0 100vw;
  scroll-snap-align: start;
`;

const CardInner = styled.div<{
  $backgroundColor: ColorOptions;
  $backgroundType: "card" | "fill";
}>`
  display: grid;
  gap: 24px;
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor]};
  border-radius: ${({ $backgroundColor }) => ($backgroundColor ? "21px" : "0")};
  ${({ $backgroundType }) =>
    $backgroundType === "card" &&
    `
    padding:16px;
  `}

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 40px 64px;
    grid-template-columns: 392px auto;
    align-items: center;
    gap: 72px;
  }
`;

const ImageContainer = styled.div<{ $backgroundType: "card" | "fill" }>`
  width: 100%;
  aspect-ratio: 327 / 285;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  height: fit-content;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    aspect-ratio: 392 / 285;
    max-height: 50vh;
  }
`;

const Pagination = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding-bottom: 16px;
`;

const Dot = styled.div<{ $active: boolean; $backgroundColor: ColorOptions }>`
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  opacity: ${({ $active }) => ($active ? 1 : 0.3)};
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor === "red" ? "creme" : "red"]};
`;

const S = {
  Section,
  Inner,
  Wrapper,
  ScrollContainer,
  IconContainer,
  Card,
  CardInner,
  ImageContainer,
  Pagination,
  Dot,
};

export default S;
